import { TranslationCustomerMessages, CustomerMessages } from "../interfaces";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationCustomerMessages = {
  [CustomerMessages.applicationDashboard]: "Tablero",
  [CustomerMessages.applicationConcretingRequest]: "Solicitud de hormigonado",
  [CustomerMessages.applicationConcretingRequestAbbreviated]: "Solicitud de horm.",
  [CustomerMessages.applicationContract]: "Contratos",
  [CustomerMessages.applicationContractAmounts]: "Importes de contrato",
  [CustomerMessages.applicationConcreting]: "Hormigonados",
  [CustomerMessages.applicationInvoice]: "Facturas",
  [CustomerMessages.applicationConcretingApproval]: "Aprobación de hormigonado",
  [CustomerMessages.applicationCertificate]: "Informes",
  [CustomerMessages.applicationClient]: "Clientes",
  [CustomerMessages.applicationPermission]: "Permisos",
  [CustomerMessages.applicationLogout]: "Cerrar sesión",
  [CustomerMessages.applicationSettings]: "Ajustes",
  [CustomerMessages.applicationDocs]: "Documentación",
  [CustomerMessages.docsTabManual]: "Manual",
  [CustomerMessages.docsTabChangelog]: "Novedades",
  [CustomerMessages.docsIndexTitle]: "Índice",
  [CustomerMessages.docsVersionsTitle]: "Versiones",
  [CustomerMessages.docsLoadError]: "No se pudo cargar la documentación.",
  [CustomerMessages.docsNoVersions]: "No se encontraron versiones.",
  [CustomerMessages.docsVersion]: "Versión <VERSION>",
  [CustomerMessages.docsWhatChanged]: "Qué cambió",
  [CustomerMessages.docsDetails]: "Detalles",
  [CustomerMessages.docsClose]: "Cerrar",
  [CustomerMessages.docsCancel]: "Cancelar",
  [CustomerMessages.docsKindAddedLabel]: "Nuevo",
  [CustomerMessages.docsKindAddedOne]: "novedad",
  [CustomerMessages.docsKindAddedMany]: "novedades",
  [CustomerMessages.docsKindImprovedLabel]: "Mejorado",
  [CustomerMessages.docsKindImprovedOne]: "mejora",
  [CustomerMessages.docsKindImprovedMany]: "mejoras",
  [CustomerMessages.docsKindFixedLabel]: "Corregido",
  [CustomerMessages.docsKindFixedOne]: "corrección",
  [CustomerMessages.docsKindFixedMany]: "correcciones",
  [CustomerMessages.docsKindBreakingLabel]: "Importante",
  [CustomerMessages.docsKindBreakingOne]: "cambio importante",
  [CustomerMessages.docsKindBreakingMany]: "cambios importantes",
  [CustomerMessages.docsKindOtherLabel]: "Otro",
  [CustomerMessages.docsKindOtherOne]: "ítem",
  [CustomerMessages.docsKindOtherMany]: "ítems",
  [CustomerMessages.docsVersionDetails]: "Novedades en detalle",
  [CustomerMessages.docsVersionRange]: "Resumen de versiones",
  [CustomerMessages.docsVersionNoDetails]: "La versión <LINE> aún no tiene detalles",
  [CustomerMessages.docsVersionDetailsTitle]: "Novedades en detalle · Versión <VERSION>",
  [CustomerMessages.docsVersionRangeTitle]: "Resumen de versiones · <FROM> → <TO>",
  [CustomerMessages.docsVersionRangeDialogTitle]: "Resumen de versiones",
  [CustomerMessages.docsVersionRangeHelp]:
    "Elija hasta <MAX> líneas de versión, como 1.19.0 → 1.20.0. El resumen junta destacados, mejoras y correcciones.",
  [CustomerMessages.docsVersionFrom]: "Desde",
  [CustomerMessages.docsVersionTo]: "Hasta",
  [CustomerMessages.docsVersionRangeTooWide]: "El intervalo abarca <COUNT> líneas (<LINES>). Elija hasta <MAX>.",
  [CustomerMessages.docsVersionOpenRange]: "Abrir resumen",
  [CustomerMessages.docsVersionLine]: "Línea <LINE>",
  [CustomerMessages.docsVersionFilter]: "Filtrar versión",
  [CustomerMessages.docsVersionNoOptions]: "Ninguna versión",
  [CustomerMessages.newVersionBanner]: "¡Nueva versión <VERSION>! Mira las novedades.",
  [CustomerMessages.newVersionSee]: "Ver novedades",
  [CustomerMessages.newVersionDismiss]: "Marcar como leído",
  [CustomerMessages.newBadge]: "Nuevo",
  [CustomerMessages.allUsersStatusIconTitle]: "All users",
  [CustomerMessages.newUsersStatusIconTitle]: "New users",
  [CustomerMessages.activeUsersStatusIconTitle]: "Usuarios activos",
  [CustomerMessages.inactiveUsersStatusIconTitle]: "Usuarios inactivos",
  [CustomerMessages.blockedUsersStatusIconTitle]: "Usuarios bloqueados",
  [CustomerMessages.inactivedUser]: "Usuario inactivo",
  [CustomerMessages.activedUser]: "Usuario activado",
  [CustomerMessages.errorInactivatingUser]: "Error al inactivar usuario",
  [CustomerMessages.errorActivatingUser]: "error al activar usuario",
  [CustomerMessages.inactivateUserTitle]: "Inactivar usuario",
  [CustomerMessages.activateUserTitle]: "Activar usuario",
  [CustomerMessages.inactivateUserText]: "¿Quieres desactivar el usuario de <USER_NAME>?",
  [CustomerMessages.activateUserText]: "¿Quieres activar el usuario <USER_NAME>?",
  [CustomerMessages.inactivateUserButton]: "Inactivar",
  [CustomerMessages.activateUserButton]: "Activar"
};
